import { createFileRoute } from "@tanstack/react-router";
import { DashboardPageShell } from "@/components/patterns/headers";

export const Route = createFileRoute("/_dashboard/about")({
  component: About,
});

function About() {
  return <DashboardPageShell>Hello from About!</DashboardPageShell>;
}
